import {
    IContraception,
    IContraceptionSearch,
  } from "@interfaces";
  import axiosClient from "./axiosClient";
  
  export const contraceptionApi = {
    exportExcel: (params: IContraceptionSearch) => {
      const url = `/contraception/export-records`;
      return axiosClient.post(url, params);
    },
    contraceptions: (params: IContraceptionSearch) => {
      const url = "contraception/get";
      return axiosClient.get(url, { params });
    },
    getContraceptionById: (id: string) => {
      const url = `/contraception/get/${id}`;
      return axiosClient.get(url);
    },
    create: (params: IContraception) => {
      const url = `/contraception/create`;
      return axiosClient.post(url, params);
    },
    update: (params: IContraception, id: string) => {
      const url = `/contraception/update/${id}`;
      return axiosClient.put(url, params);
    },
    autocompleteSearchClinic: (params: string) => {
      const url = `/contraception/autocomplete/clinic?clinicName=${params}`;
      return axiosClient.get(url);
    }
  };
  